import 'bootstrap/dist/css/bootstrap.min.css'
import 'font-awesome/css/font-awesome.min.css'
import './App.css'
import React from 'react'
import { HashRouter } from 'react-router-dom'
import Routes from './FormRoutes'

export default () => {
   let vh = window.innerHeight * 0.01
   document.documentElement.style.setProperty('--vh', `${vh}px`)
    return(
        <HashRouter>
            <div className="app">
                <Routes/>
            </div>
        </HashRouter>
    )
}